export default __webpack_public_path__ + "static/media/ic_camera.6b7f6066.svg";